export const isExternalBannerUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (trimmed.startsWith('/')) return false;
  if (/^https?:\/\//i.test(trimmed)) return true;
  const host = trimmed.split('/')[0];
  return /^[a-zA-Z0-9][-a-zA-Z0-9.]*\.[a-zA-Z]{2,}/.test(host);
};

export const formatExternalUrl = (url) => {
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export const normalizeInternalPath = (url) => {
  const trimmed = url.trim();
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const openBannerLink = (url, navigate) => {
  if (!url) return;
  if (isExternalBannerUrl(url)) {
    window.open(formatExternalUrl(url), '_blank');
  } else {
    navigate(normalizeInternalPath(url));
  }
};
